/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const LLMChatActionTypes = {
  
    APPLY_SCREENER_SURVEY: 'LLMChatActions::ApplyScreenerSurvey' as const,
  
    ASSIGN_CRITERIA: 'LLMChatActions::AssignCriteria' as const,
  
    CREATE_DRAFT_PROJECT: 'LLMChatActions::CreateDraftProject' as const,
  
    GENERATE_SCREENER_SURVEY: 'LLMChatActions::GenerateScreenerSurvey' as const,
  
    PREVIEW_UNMODERATED_TASK: 'LLMChatActions::PreviewUnmoderatedTask' as const,
  
    UPLOAD_SIGNATURE_DOCUMENT: 'LLMChatActions::UploadSignatureDocument' as const,
  
} as const;

export type LLMChatActionType = typeof LLMChatActionTypes[keyof typeof LLMChatActionTypes];
